import { ButtonTrigger, Device, IObjectTrigger, Slot, TriggerDTO } from "client-generator/generated-clients/plants";
import i18n from "../translations/i18n";

export class SceneButtonUtils {
  private static $t = i18n.global.t;
  
  public static getButtonTriggerName(trg: TriggerDTO): string {
            
    const deviceTrigger = (trg.triggerParams as ButtonTrigger)?.devices?.find(d => !!d.id);
    let nameToShow = this.$t('AppResource.Button');
    if (!deviceTrigger) return nameToShow;

    nameToShow = `${deviceTrigger?.model} - ID ${deviceTrigger?.id}`;
    return nameToShow;
  }

  public static getButtonTriggerDescription(
    buttonTrigger: IObjectTrigger,
    sceneId: string
  ): string {
    const devices = (buttonTrigger as ButtonTrigger).devices;
    if (!devices) return '';

    const descriptions: string[] = [];
    
    for (const device of devices) {
      const deviceDescription = this.getDeviceDescription(device, sceneId);
      if (deviceDescription) {
        descriptions.push(deviceDescription);
      }
    }

    return descriptions.join(' | ');
  }

  private static getDeviceDescription(device: Device, sceneId: string): string {
    if (!device?.slots) return '';

    const sortedSlots = device.slots.slice().sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
    const slotDescriptions: string[] = [];

    for (const slot of sortedSlots) {
      const slotDescription = this.getSlotDescription(slot, sceneId);
      if (slotDescription) {
        slotDescriptions.push(slotDescription);
      }
    }

    return slotDescriptions.join(' | ');
  }

  private static getSlotDescription(slot: Slot, sceneId: string): string {
    if (!slot.scenes_id || !slot.configured) return '';
    
    const matchingScene = slot.scenes_id.find((scene: any) => scene.id === sceneId);
    if (!matchingScene) return '';

    const slotIndex = slot.index ?? '';
    let description = `${this.$t('AppResource.ModuleUpper')} ${slotIndex}`;

    // SceneButtonMode: EntireSlot = 0, UpperButton = 1, LowerButton = 2
    if (matchingScene.button === 1) {
      description += ` - ${this.$t('AppResource.Up')}`;
    } else if (matchingScene.button === 2) {
      description += ` - ${this.$t('AppResource.Down')}`;
    }

    return description;
  }
}